import { HTTP } from '@/utils/http-common'

export default {
    list_configs (parent) {
        return new Promise((resolve, reject) => {
                const projectId = parent.$route.params.project
                return HTTP.get(`/projects/manage/${projectId}/config/`).then(res => {
                    return resolve(res)
                }).catch(err => {
                    return reject(err)
                })
            })
            // if (page === 0) {} else if (page !== null) {
            //     return HTTP.get(page)
            // } else {
            //     return {}
            // }
    },
    list (parent, page) {
        return new Promise((resolve, reject) => {
                return HTTP.get('/integrations/list/').then(res => {
                    return resolve(res)
                }).catch(err => {
                    return reject(err)
                })
            })
            // if (page === 0) {} else if (page !== null) {
            //     return HTTP.get(page)
            // } else {
            //     return {}
            // }
    },
    simpleList (parent, page) {
        if (page === 0) {
            return HTTP.get('/integrations/simple_list/')
        } else if (page !== null) {
            return HTTP.get(page)
        } else {
            return {}
        }
    },
    listStorage (parent, page) {
        if (page === 0) {
            return HTTP.get('/integrations/list/?labels__contains=storage')
        } else if (page !== null) {
            return HTTP.get(page)
        } else {
            return {}
        }
    },
    getConfig (parent, configId) {
        return HTTP.get('/integrations/config/manage/' + configId + '/')
    },
    createConfiguration (config, parent) {
        return new Promise((resolve, reject) => {
            return HTTP.post('/integrations/config/manage/', config).then(res => {
                resolve(res)
            }).catch(err => {
                parent.$store.commit('push', {
                    msg: `Errors : \n${_.join(_.map(err.response.data, (el, label) => { return label + ' : ' + el }), '\n')}`,
                    color: 'error',
                })
                reject(err)
            })
        })
    },
    updateConfiguration (config, parent) {
        return new Promise((resolve, reject) => {
            return HTTP.put('/integrations/config/manage/' + config.id + '/', config).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    },
    deleteConf (confId, parent) {
        return HTTP.delete('/integrations/config/manage/' + confId + '/')
    },

}
